import { Landing } from 'components';

export default function Home() {
    return <Landing />;
}
